<template>
  <div class="CategoriasListado">
    <div class="row">
      <div class="col-sm-8 col-md-6 col-sm-offset-2 col-md-offset-3">
        <md-table v-model="filtro_categorias" md-card md-fixed-header>
          <md-button class="md-fab md-fab-bottom-right" @click.native="abrirModalNuevaCategoria()">
            <md-icon>add</md-icon>
          </md-button>
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="md-title">Categorías</h1>
            </div>
            <md-field md-clearable class="md-toolbar-section-end">
              <md-input placeholder="Buscar categoría..." v-model="buscar" @input="buscarEnLaTabla" />
            </md-field>
          </md-table-toolbar>
          <md-table-empty-state md-label="No se encontraron categorías" :md-description="``"></md-table-empty-state>
          <md-table-row slot="md-table-row" slot-scope="{ item }" class="md-accent" md-selectable="single">
            <md-table-cell md-label="Nombre">{{ item.desc_cat }} </md-table-cell>
            <md-table-cell md-label="Estatus">{{ item.estatus_cat.toUpperCase() }} </md-table-cell>
            <md-table-cell md-label="Acciones">
              <md-button class="md-icon-button" @click.native="editarCategoria(item)">
                <md-icon>edit</md-icon>
                <md-tooltip md-direction="left">Editar</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
    <md-dialog :md-active.sync="mostrarModalNuevaCategoria">
      <md-dialog-title>Nueva categoría</md-dialog-title>
      <md-dialog-content>
        <md-field :class="v.desc_cat">
          <label>Nombre de categoría</label>
          <md-input v-model="categoria.desc_cat" maxlength="50" required></md-input>
        </md-field>
        <md-field>
          <label>Icono</label>
          <md-file v-model="file_icono" @md-change="prepararArchivoASubir" accept="image/x-png,image/jpeg,image/svg+xml,image/svg" />
        </md-field>
        <md-field :class="v.estatus_cat">
          <label for="estatus_cat">Estatus de categoría</label>
          <md-select v-model="categoria.estatus_cat" name="estatus_cat" id="estatus_cat" required>
            <md-option value="activa">Activa</md-option>
            <md-option value="inactiva">Inactiva</md-option>
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="mostrarModalNuevaCategoria = false">Cancelar</md-button>
        <md-button class="md-raised md-accent" @click.native="guardarCategoria()">Guardar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="mostrarModalEditarCategoria">
      <md-dialog-title>Editar categoría</md-dialog-title>
      <md-dialog-content>
        <md-field :class="v.desc_cat">
          <label>Nombre de categoría</label>
          <md-input v-model="categoria.desc_cat" maxlength="50" required></md-input>
        </md-field>
        <div v-if="categoria.icono_cat">
          <img style="width: 25px;" :src="'http://localhost/cfosc/api/archivos/categorias/'+categoria.icono_cat" alt="Icono de la categoría" /> Icono actual
        </div>
        <md-field>
          <label>Icono</label>
          <md-file v-model="file_icono" @md-change="prepararArchivoASubir" accept="image/x-png,image/jpeg,image/svg+xml,image/svg" />
        </md-field>
        <md-field :class="v.estatus_cat">
          <label for="estatus_cat">Estatus de categoría</label>
          <md-select v-model="categoria.estatus_cat" name="estatus_cat" id="estatus_cat" required>
            <md-option value="activa">Activa</md-option>
            <md-option value="inactiva">Inactiva</md-option>
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="mostrarModalEditarCategoria = false">Cancelar</md-button>
        <md-button class="md-raised md-accent" @click.native="actualizarCategoria()">Actualizar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";

const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarNombre = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.desc_cat).includes(toLower(term)));
  }
  return items;
};

export default {
  name: "CategoriasListado",
  methods: {
    buscarEnLaTabla() {
      this.filtro_categorias = buscarNombre(this.categorias, this.buscar);
    },
    obtenerCategorias() {
      this.$http
        .post("categorias", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "categorias" in response.body) {
              this.categorias = response.body.categorias;
              this.filtro_categorias = response.body.categorias;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener la categoría. Inténtelo de nuevo.";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    guardarCategoria() {
      if (this.validarCamposCategoria()) {
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("icono", this.icono);
        formData.append("data", JSON.stringify(this.categoria));
        this.$http.post("categorias/guardar", formData).then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.$parent.sb.texto = response.body.msg;
              this.obtenerCategorias();
              this.mostrarModalNuevaCategoria = false;
            } else {
              this.$parent.sb.texto = response.body.error;
            }
            this.$parent.sb.mostrar = true;
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para guardar la categoría. Inténtelo de nuevo.";
            this.$parent.sb.mostrar = true;
          }
        );
      }
    },
    validarCamposCategoria() {
      this.v.desc_cat = !this.categoria.desc_cat ? "md-invalid" : false;
      this.v.estatus_cat = !this.categoria.estatus_cat ? "md-invalid" : false;
      if (this.v.desc_cat || this.v.estatus_cat) {
        this.$parent.sb.texto = "Por favor llene los campos marcados con *";
        this.$parent.sb.mostrar = true;
      } else {
        return true;
      }
    },
    abrirModalNuevaCategoria() {
      this.categoria.id_cat = null;
      this.categoria.desc_cat = null;
      this.file_icono = null;
      this.categoria.estatus_cat = "activa";
      this.mostrarModalNuevaCategoria = true;
    },
    editarCategoria(c) {
      this.file_icono = c.icono_cat;
      this.categoria.id_cat = c.id_cat;
      this.categoria.desc_cat = c.desc_cat;
      this.categoria.estatus_cat = c.estatus_cat;
      this.categoria.icono_cat = c.icono_cat;
      this.mostrarModalEditarCategoria = true;
    },
    actualizarCategoria() {
      if (this.validarCamposCategoria()) {
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("c", this.categoria.id_cat);
        formData.append("icono", this.icono);
        formData.append("data", JSON.stringify(this.categoria));
        this.$http.post("categorias/actualizar", formData).then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.$parent.sb.texto = response.body.msg;
              this.obtenerCategorias();
              this.mostrarModalEditarCategoria = false;
            } else {
              this.$parent.sb.texto = response.body.error;
            }
            this.$parent.sb.mostrar = true;
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para actualizar la categoría. Inténtelo de nuevo.";
            this.$parent.sb.mostrar = true;
          }
        );
      }
    },
    prepararArchivoASubir(e) {
      console.dir(e);
      this.icono = e[0];
    }
  },
  data() {
    return {
      buscar: null,
      filtro_categorias: [],
      mostrarModalNuevaCategoria: false,
      mostrarModalEditarCategoria: false,
      categorias: [],
      categoria: {
        id_cat: null,
        desc_cat: null,
        estatus_cat: null,
        icono_cat: null
      },
      file_icono: null,
      icono: null,
      v: {
        id_cat: null,
        desc_cat: null,
        estatus_cat: null
      }
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerCategorias();
  }
};
</script>